import React from 'react';
import PropTypes from 'prop-types';
import { intl } from 'components/LocaleProvider';
import DiseaseListItem from './DiseaseListItem';

import messages from './messages';

const DiseaseList = ({ widget }) => {
  const { content: diseases } = widget;
  const splitIntoColumns = (arr) => {
    const columns = [];
    const len = Math.round(arr.length / 4);
    let i = 0;
    while (i < arr.length) {
      columns.push({
        list: arr.slice(i, i += len),
        id: i,
      });
    }
    return columns;
  };
  return (
    <section id="diseases-list-widget" className="widget">
      <div className="section-title main-border">
        <span className="label text-uppercase titles-color">{intl.formatMessage(messages.title)}</span>
      </div>
      <div className="row">
        {
          splitIntoColumns(diseases, 7).map((items) => (
            <div className="list-col col-xs-12 col-sm-6 col-md-3" key={items.id}>
              {items.list.map((item) => <DiseaseListItem item={item} key={item.id} />)}
            </div>
          ))
        }
      </div>
    </section>
  );
};

DiseaseList.defaultProps = {
  widget: {
    options: {},
    content: [],
  },
};

DiseaseList.propTypes = {
  widget: PropTypes.object,
};

export default DiseaseList;
